/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { useTranslation } from "@i18n";
import { useEffect, useState } from "react";
import SpacesTab from "./SpacesTab";
import LeftAccordionIcon from "@Assets/icons/Accordian.svg";
import { useNavigate, useParams } from "react-router-dom";
import { getProjectTemplatesUrl } from "@Features/projects/utils/projectUrls";
import { getProjectTemplatesData } from "./projectTemplates.helper";

const SpacesInProjectTemplate = (props: any) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("spaces");
  const [projectTemplateData, setProjectTemplateData] = useState<any>({});
  const navigate = useNavigate();
  const changeActiveTab = (e: React.MouseEvent<HTMLElement>) => {
    setActiveTab((e.target as HTMLElement).id);
    props.setProjectTemplateData();
  };
  const templateData = useParams();

  const handleBack = () => {
    navigate(getProjectTemplatesUrl());
  };

  const init = async () => {
    const result = await getProjectTemplatesData({
      value: {
        where: [
          {
            isComplex: false,
            field: "_id",
            operator: "equal",
            value: templateData.dsrId,
            ignoreCase: true,
            ignoreAccent: false,
          },
        ],
      },
    });
    const list = (result as any[]) ?? [];
    if (list.length) {
      setProjectTemplateData(list[0]);
    }
  };

  useEffect(() => {
    if (props.projectTemplateData) {
      setProjectTemplateData(props.projectTemplateData);
    } else {
      init();
    }
  }, []);

  const header = () => (
    <div className="flex flex-col gap-2 ps-4 pb-2 w-full">
      <div className="flex gap-1 items-center">
        <img src={LeftAccordionIcon} onClick={handleBack} className="cursor-pointer mt-1" />
        <span className="text-2xl font-semibold">{projectTemplateData.name}</span>
      </div>
      <div>
        <span className="text-sm">{projectTemplateData.description}</span>
      </div>
    </div>
  );

  const headerTabs = () => (
    <div className="bg-white border min-h-12 h-12 flex items-end ps-8 border-s-0 text-sm gap-12">
      <div className="w-fit flex flex-col items-center">
        <div
          id="spaces"
          className={`cursor-pointer text-center ${activeTab === "spaces" ? "mb-2.5" : "mb-3.5"} text-sm font-semibold`}
          onClick={changeActiveTab}
        >
          {t("Spaces")}
        </div>
        {activeTab === "spaces" && (
          <div className="mb-1 w-full min-w-max h-1.5 rounded-lg bg-gradient-to-r from-gradient_color to-primary_gradient_color2" />
        )}
      </div>
    </div>
  );

  return (
    <div className="w-full flex flex-col h-full bg-#f0f5f9">
      {projectTemplateData && header()}
      {headerTabs()}
      {activeTab === "spaces" && <SpacesTab />}
    </div>
  );
};
export default SpacesInProjectTemplate;
